package kz.dentalcrm.app.data.network

import io.ktor.client.HttpClient
import io.ktor.client.request.header
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.HttpMethod
import io.ktor.http.contentType
import io.ktor.http.headers
import io.ktor.http.path
import kz.dentalcrm.app.core.network.handle
import kz.dentalcrm.app.core.storage.Storage
import kz.dentalcrm.app.data.network.request_model.Name
import kz.dentalcrm.app.data.network.response_model.diagnosis.DiagnosisResponse

class DiagnosisApi(
    private val httpClient: HttpClient,
    private val storage: Storage,
) {
    suspend fun getDiagnosis(
        page: Int,
        search: String = "",
        pageSize: Int = 100
    ) = httpClient.handle<DiagnosisResponse?> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path(
                "api/v1/diagnosis-paginate"
            )
            parameters.append("page", page.toString())
            parameters.append("perPage", pageSize.toString())
            if (search.isNotEmpty()) {
                parameters.append("search", search)
            }
        }
        method = HttpMethod.Get
    }

    suspend fun addDiagnosis(
        name: String,
    ) = httpClient.handle<Any?> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path(
                "api/v1/diagnosis"
            )
            setBody(
                Name(
                    name = name
                )
            )
        }
        method = HttpMethod.Post
    }

    suspend fun deleteDiagnosis(
        id: Int,
    ) = httpClient.handle<Any?> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path(
                "api/v1/diagnosis/${id}"
            )
        }
        method = HttpMethod.Delete
    }

    suspend fun updateDiagnosis(
        id: Int,
        name: String,
    ) = httpClient.handle<Any?> {
        contentType(ContentType.Application.Json)
        url {
            headers {
                header("Authorization", "Bearer ${storage.getAccessToken()}")
            }
            path(
                "api/v1/diagnosis"
            )
            setBody(
                Name(
                    name = name,
                    id = id
                )
            )
        }
        method = HttpMethod.Post
    }
}